// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2SLfU","info":"UpdateTermsInfo_info__pkHWH"};